module.exports = __webpack_public_path__ + "img/create-bond-hide.ae1c769a.png";